import { useHits, useSearchBox } from 'react-instantsearch-hooks';
import { useHistory } from 'react-router-dom';

function cx(
  ...classNames
) {
  return classNames.filter(Boolean).join(' ');
}

export default function Hits({
  hitComponent: Hit,
  ...props
}) {
  const { hits } = useHits(props);
  const { query } = useSearchBox();
  const history = useHistory();

  return (
    <div id="marketPlaceResults" className={cx('ais-Hits', props.className)}>
      <ol className="ais-Hits-list">
        {hits.map((hit) => (
          <li key={hit.objectID} className="pl-8 hover:bg-grey-filterHover ais-Hits-item">
            <Hit hit={hit} />
          </li>
        ))}
      </ol>
      <div className="py-4" style={{
        borderTop: '1px solid rgba(214, 216, 222, 1)',
      }}>
        {hits.length > 0 && <button 
          type="button" 
          className="underline text-body-1-md text-blue-700 font-primary"
          onClick={() => {
            // history.push();
            window.location.assign('/marketplace/search?query=' + query);
          }}
        >View all results</button>}
        {hits.length === 0 && query.length > 0 && <p className="text-center text-body-1-md text-blue-700 font-primary">Hmm… no results here. Try searching for something else.</p>}
      </div>
    </div>
  );
}
